import { render, staticRenderFns } from "./CheckboxesWithValidation.vue?vue&type=template&id=372f005b"
import script from "./CheckboxesWithValidation.vue?vue&type=script&lang=js"
export * from "./CheckboxesWithValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports